import { SomeEntity } from '~/clients/api-guards'

/**
 * Calls a function for each entity in a list of entities, including nested entities,
 * but only once per encountered entity. The callback is provided with a shallow
 * entity (without any nested entities).
 */
export function walkEntities(entitiesToTraverse: SomeEntity[], entityEncounterCallback: (entity: SomeEntity) => void): void {
    // Use nested Map for O(1) lookup: Map<entity_type, Set<id>>
    const processedEntities = new Map<string, Set<number | string>>()

    function walkEntity(entity: SomeEntity) {
        const entityType = entity.entity_type
        const entityId = entity.id

        let typeSet = processedEntities.get(entityType)
        if (typeSet) {
            if (typeSet.has(entityId)) {
                return // Skip if already processed
            }
        } else {
            typeSet = new Set()
            processedEntities.set(entityType, typeSet)
        }
        typeSet.add(entityId)

        for (const key in entity) {
            const value = entity[key]
            if (typeof value === 'object' && value !== null) {
                if ('entity_type' in value) {
                    walkEntity(value as SomeEntity)
                    delete entity[key]
                } else if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'object' && value[0] !== null && 'entity_type' in value[0]) {
                    for (let j = 0; j < value.length; j++) {
                        walkEntity(value[j] as SomeEntity)
                    }
                    delete entity[key]
                }
            }
        }

        // Call the callback function with the cleaned entity
        entityEncounterCallback(entity)
    }

    for (let i = 0; i < entitiesToTraverse.length; i++) {
        const entity = entitiesToTraverse[i]
        if (entity) {
            walkEntity(entity)
        }
    }
}
